import { useState } from "react";
import { FileBarChart2, X } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { usePermissao } from "@/lib/use-permissao";

const CHAVE = "financeiro:convite-do-dre-dispensado";
const lerDispensado = () => {
  try {
    return localStorage.getItem(CHAVE) === "1";
  } catch {
    return false;
  }
};

/** Convite discreto para ligar o DRE, só para quem pode configurar e enquanto ele está desligado. */
export function ConviteDoDre({ onIr }: { onIr: (aba: string) => void }) {
  const pode = usePermissao("finance.manage");
  const config = trpc.financeiro.configFinanceira.ler.useQuery(undefined, { enabled: pode }).data;
  const [dispensado, setDispensado] = useState(lerDispensado);
  if (!pode || !config || config.dreLigado || dispensado) return null;
  const dispensar = () => {
    setDispensado(true);
    try {
      localStorage.setItem(CHAVE, "1");
    } catch {
      // Sem armazenamento, o convite só volta na próxima visita.
    }
  };
  return (
    <div className="flex items-center gap-3 rounded-xl border border-zinc-200 bg-white px-4 py-3 shadow-sm dark:border-border dark:bg-card">
      <FileBarChart2 className="h-5 w-5 shrink-0 text-brand-600 dark:text-primary" />
      <p className="min-w-0 flex-1 text-sm text-zinc-700 dark:text-foreground/80">
        <span className="font-semibold text-zinc-900 dark:text-foreground">Ver o DRE do mês?</span> Para quem lança tudo: o resultado em linhas, com impostos, custos e despesas.
      </p>
      <button type="button" onClick={() => onIr("configuracoes")} className="shrink-0 text-sm font-semibold text-brand-700 hover:underline dark:text-primary">
        Conhecer
      </button>
      <button type="button" aria-label="Dispensar" onClick={dispensar} className="shrink-0 rounded-md p-1 text-zinc-400 hover:bg-zinc-100 hover:text-zinc-600 dark:hover:bg-muted">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
